import { Typography } from "antd"

import Flex from "#blocks/Flex"

import {
  ESSAY_CHAR_LIMIT,
  ESSAY_LABELS,
  ESSAY_PROMPTS,
} from "./portfolioEssayConstants"
import { type PortfolioStatementKey } from "./portfolioUiTypes"

const { Paragraph, Text } = Typography

interface EssayRowProps {
  essayKey: PortfolioStatementKey
  value: string
  isActive: boolean
  onSelect: () => void
}

/**
 * Selectable row for one Sustained Investigation essay in the left project
 * list. Essays are pseudo-projects: not draggable, no steps, no drop target.
 */
const EssayRow = ({ essayKey, value, isActive, onSelect }: EssayRowProps) => {
  const hasValue = value.trim().length > 0
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(event) => {
        if (event.key !== "Enter" && event.key !== " ") return
        event.preventDefault()
        onSelect()
      }}
      style={{
        all: "unset",
        cursor: "pointer",
        display: "block",
        borderRadius: 8,
        border: isActive ? "1px solid #91caff" : "1px solid #f0f0f0",
        padding: "6px 8px",
        background: isActive ? "#e6f4ff" : "transparent",
        transition: "all 0.15s ease-in-out",
      }}
    >
      <Flex col gap={2} style={{ minWidth: 0 }}>
        <Text strong ellipsis style={{ fontSize: 14 }}>
          {ESSAY_LABELS[essayKey]}
        </Text>
        {hasValue ? (
          <Paragraph
            type="secondary"
            ellipsis={{ rows: 2 }}
            style={{ fontSize: 12, marginBottom: 0, whiteSpace: "pre-wrap" }}
          >
            {value}
          </Paragraph>
        ) : (
          <Paragraph
            type="secondary"
            italic
            ellipsis={{ rows: 2 }}
            style={{ fontSize: 12, marginBottom: 0 }}
          >
            {ESSAY_PROMPTS[essayKey]}
          </Paragraph>
        )}
        <Text
          type={value.length > ESSAY_CHAR_LIMIT ? "danger" : "secondary"}
          style={{ fontSize: 11 }}
        >
          {value.length}/{ESSAY_CHAR_LIMIT}
        </Text>
      </Flex>
    </div>
  )
}

export default EssayRow
